/**
 * @export
 * @enum {string}
 */
export enum DismissalCodeEnum {
    CAUGHT = 'CAUGHT',
    BOWLED = 'BOWLED',
    LBW = 'LBW',
    RUNOUT = 'RUN_OUT',
    CAUGHTANDBOWLED = 'CAUGHT_AND_BOWLED',
    STUMPED = 'STUMPED',
    HITWICKET = 'HIT_WICKET',
    HITTWICE = 'HIT_TWICE',
    OBSTRUCTINGTHEFIELD = 'OBSTRUCTING_THE_FIELD',
    TIMEDOUT = 'TIMED_OUT',
    HANDLEDBALL = 'HANDLED_BALL',
    RETIREDHURT = 'RETIRED_HURT',
    RETIRED = 'RETIRED'
}

/**
 * @export
 * @enum {string}
 */
export enum ReviewResultEnum {
    PENDING = 'PENDING',
    RETAINED = 'RETAINED',
    LOST = 'LOST',
}

/**
    * @export
    * @enum {string}
    */
export enum CodeEnum {
    AFG = 'AFG',
    AUS = 'AUS',
    BAN = 'BAN',
    ENG = 'ENG',
    IND = 'IND',
    IRE = 'IRE',
    NAM = 'NAM',
    NEP = 'NEP',
    NZ = 'NZ',
    OMA = 'OMA',
    PAK = 'PAK',
    SA = 'SA',
    SL = 'SL',
    WI = 'WI',
    ZIM = 'ZIM',
    PNG = 'PNG',
    SCOT = 'SCOT'
}

export enum GenderEnum {
    Male = 'Male',
    Female = 'Female'
}

/**
     * @export
     * @enum {string}
     */
export enum CountryEnum {
    AFG = 'AFG',
    ATG = 'ATG',
    AUS = 'AUS',
    AUT = 'AUT',
    BGD = 'BGD',
    BRB = 'BRB',
    BEL = 'BEL',
    BMU = 'BMU',
    BWA = 'BWA',
    BGR = 'BGR',
    CAN = 'CAN',
    HRV = 'HRV',
    CYP = 'CYP',
    CZE = 'CZE',
    DNK = 'DNK',
    DMA = 'DMA',
    GBR = 'GBR',
    GBNIR = 'GB-NIR',
    EST = 'EST',
    FIN = 'FIN',
    FRA = 'FRA',
    DEU = 'DEU',
    GIB = 'GIB',
    GRC = 'GRC',
    GRD = 'GRD',
    GGY = 'GGY',
    GUY = 'GUY',
    HKG = 'HKG',
    HUN = 'HUN',
    IND = 'IND',
    IRL = 'IRL',
    IMN = 'IMN',
    JAM = 'JAM',
    JEY = 'JEY',
    KEN = 'KEN',
    MYS = 'MYS',
    MLT = 'MLT',
    NAM = 'NAM',
    NPL = 'NPL',
    NLD = 'NLD',
    NZL = 'NZL',
    NOR = 'NOR',
    OMN = 'OMN',
    PAK = 'PAK',
    PNG = 'PNG',
    PRT = 'PRT',
    QAT = 'QAT',
    ROU = 'ROU',
    KNA = 'KNA',
    LCA = 'LCA',
    VCT = 'VCT',
    GBSCT = 'GB-SCT',
    SRB = 'SRB',
    SLE = 'SLE',
    SGP = 'SGP',
    ZAF = 'ZAF',
    ESP = 'ESP',
    LKA = 'LKA',
    SWE = 'SWE',
    CHE = 'CHE',
    THA = 'THA',
    TTO = 'TTO',
    TUR = 'TUR',
    UGA = 'UGA',
    ARE = 'ARE',
    USA = 'USA',
    ZWE = 'ZWE'
}

/**
 * @export
 * @enum {string}
 */
export enum BattingHandEnum {
    Left = 'Left',
    Right = 'Right'
}
/**
 * @export
 * @enum {string}
 */
export enum BowlingStyleEnum {
    RF = 'RF',
    RFM = 'RFM',
    RMF = 'RMF',
    RM = 'RM',
    RMS = 'RMS',
    RSM = 'RSM',
    RS = 'RS',
    LF = 'LF',
    LFM = 'LFM',
    LMF = 'LMF',
    LM = 'LM',
    LMS = 'LMS',
    LSM = 'LSM',
    LS = 'LS',
    OB = 'OB',
    LB = 'LB',
    LBG = 'LBG',
    LA = 'LA',
    LW = 'LW',
    LAG = 'LAG',
}
/**
 * @export
 * @enum {string}
 */
export enum PlayingRoleEnum {
    Batter = 'Batter',
    OpeningBatter = 'Opening Batter',
    ToporderBatter = 'Top order Batter',
    MiddleorderBatter = 'Middle order Batter',
    Wicketkeeper = 'Wicketkeeper',
    WicketkeeperBatter = 'Wicketkeeper Batter',
    Bowler = 'Bowler',
    Allrounder = 'Allrounder',
    BattingAllrounder = 'Batting Allrounder',
    BowlingAllrounder = 'Bowling Allrounder',
}

/**
* @export
* @enum {string}
*/
export enum MatchTypeEnum {
    Test = 'Test',
    ODI = 'ODI',
    T20 = 'T20',
    FirstClass = 'FirstClass',
    ListA = 'ListA',
    Twenty20 = 'Twenty20'
}

/**
     * @export
     * @enum {string}
     */
export enum TossDecisionEnum {
    Bat = 'Bat',
    Bowl = 'Bowl'
}
/**
 * @export
 * @enum {string}
 */
export enum ResultEnum {
    HOME_WIN = 'Home Win',
    AWAY_WIN = 'Away Win',
    CONCEDED = 'Conceded',
    // CANCELLED = 'Cancelled',
    // POSTPONED = 'Postponed',
    AWARDED = "Awarded",
    FORFEITURE = "Forfeiture",
    ABANDONED = 'Abandoned',
    DRAW = 'Draw',
    TIE = 'Tie',
    NO_RESULT = "No Result",
    NOT_STARTED = 'Not Started',
    IN_PROGRESS = 'In Progress',
}
/**
 * @export
 * @enum {string}
 */
export enum SeasonEnum {
    _202324 = '2023-24',
    _202425 = '2024-25',
    _202526 = '2025-26',
    _202627 = '2026-27',
    _202728 = '2027-28'
}
export enum BreaksEnum {
    DRINKS_BREAK = "DRINKS_BREAK",
    LUNCH_BREAK = "LUNCH_BREAK",
    TEA_BREAK = "TEA_BREAK",
    END_OF_DAY_BREAK = "END_OF_DAY_BREAK",
    INJURY_BREAK = "INJURY_BREAK",
    RAIN_BREAK = "RAIN_BREAK",
    BAD_LIGHT_BREAK = "BAD_LIGHT_BREAK"
}


/**
 * 
 * @export
 * @interface Delivery
 */
export interface Delivery {
    /**
     * The delivery number
     * @type {number}
     * @memberof Delivery
     */
    number: number;
    /**
     * The ball number
     * @type {number}
     * @memberof Delivery
     */
    ball: number;
    /**
     * The over number
     * @type {number}
     * @memberof Delivery
     */
    over: number;
    /**
     * The innings number
     * @type {number}
     * @memberof Delivery
     */
    innings: number;
    /**
     * Indicates if a new ball was taken
     * @type {boolean}
     * @memberof Delivery
     */
    newBallTaken: boolean;
    /**
     * The total runs scored
     * @type {number}
     * @memberof Delivery
     */
    runs?: number;
    /**
     * Indicates if a four or six boundary was hit
     * @type {number}
     * @memberof Delivery
     */
    boundaryRuns?: number;
    /**
     * Indicates if the delivery is valid - e.g. not a no ball or wide
     * @type {boolean}
     * @memberof Delivery
     */
    isValid?: boolean;
    /**
     * Indicates if the delivery was a free hit
     * @type {boolean}
     * @memberof Delivery
     */
    freeHit: boolean;
    /**
     * The number of no balls
     * @type {number}
     * @memberof Delivery
     */
    noballs?: number;
    /**
     * The number of wides
     * @type {number}
     * @memberof Delivery
     */
    wides?: number;
    /**
     * The number of byes
     * @type {number}
     * @memberof Delivery
     */
    byes?: number;
    /**
     * The number of leg byes
     * @type {number}
     * @memberof Delivery
     */
    legbyes?: number;
    /**
     * 
     * @type {DeliveryStriker}
     * @memberof Delivery
     */
    striker: DeliveryStriker;
    /**
     * 
     * @type {DeliveryNonStriker}
     * @memberof Delivery
     */
    nonStriker: DeliveryNonStriker;
    /**
     * 
     * @type {DeliveryBowler}
     * @memberof Delivery
     */
    bowler: DeliveryBowler;
    /**
     * Indicates if the powerplay is active
     * @type {boolean}
     * @memberof Delivery
     */
    powerplay: boolean;
    /**
     * The bowling end
     * @type {string}
     * @memberof Delivery
     */
    bowlingEnd: BowlingEndEnum;
    /**
     * The bowling speed in km/h
     * @type {number}
     * @memberof Delivery
     */
    bowlingSpeed?: number;
    /**
     * List of dismissals for the delivery
     * @type {Array<DeliveryDismissal>}
     * @memberof Delivery
     */
    dismissal: Array<DeliveryDismissal>;
    /**
     * List of dismissals for the delivery
     * @type {Array<BreaksEnum>}
     * @memberof Delivery
     */
    breaks?: Array<BreaksEnum>;
}


/**
 * @export
 * @enum {string}
 */
export enum BowlingEndEnum {
    NORTH = 'NORTH',
    SOUTH = 'SOUTH'
}

/**
 * 
 * @export
 * @interface DeliveryBatsman
 */
export interface DeliveryBatsman {
    /**
     * The ID of the batsmen out
     * @type {string}
     * @memberof DeliveryBatsman
     */
    id: string;
    /**
     * The name of the batsmen out
     * @type {string}
     * @memberof DeliveryBatsman
     */
    name: string;
}

export interface Innings {
    /**
     * The Innings number
     * @type {number}
     * @memberof Innings
     */
    inningsData: Array<object>;
}

export interface InningsData {
    /**
     * The Innings number
     * @type {number}
     * @memberof InningsData
     */
    number: number;
    /**
     * The batting team object
     * @type {object}
     * @memberof InningsData
     */
    battingTeam: object;
    /**
     * The bowling team object
     * @type {object}
     * @memberof InningsData
     */
    bowlingTeam: object;
    /**
     * The array of partnership objects
     * @type {Array<object>}
     * @memberof InningsData
     */
    partnerships: Array<object>;
    /**
     * The array of batting summary objects
     * @type {Array<object>}
     * @memberof InningsData
     */
    battingSummary: Array<object>;
    /**
    * The score number
    * @type {number}
    * @memberof InningsData
    */
    score: number;
    /**
   * The number of wickets
   * @type {number}
   * @memberof InningsData
   */
    wickets: number;
    /**
   * Boolean on declared status
   * @type {boolean}
   * @memberof InningsData
   */
    declared: boolean;
    /**
  * Boolean on if all out
  * @type {boolean}
  * @memberof InningsData
  */
    allOut: boolean;
    /**
   * the overs represented as a string
   * @type {string}
   * @memberof InningsData
   */
    overs: string;
    /**
   * The number of balls
   * @type {number}
   * @memberof InningsData
   */
    balls: number;
    /**
   * extras accumulated in an object
   * @type {Object}
   * @memberof InningsData
   */
    extras: object;
    /**
    * The arry of previous deliveries
    * @type {Array<object>}
    * @memberof InningsData
    */
    previousDeliveries: Array<object>;
    /**
    * The last delivery sent
    * @type {Object}
    * @memberof InningsData
    */
    lastDelivery: object;
    /**
    * The object of a started delivery
    * @type {Object}
    * @memberof InningsData
    */
    nextDelivery: object;
}

/**
 * 
 * @export
 * @interface DeliveryBowler
 */
export interface DeliveryBowler {
    /**
     * The ID of the bowler
     * @type {string}
     * @memberof DeliveryBowler
     */
    id: string;
    /**
     * The name of the bowler
     * @type {string}
     * @memberof DeliveryBowler
     */
    name: string;
}
/**
 * 
 * @export
 * @interface DeliveryBowler1
 */
export interface DeliveryBowler1 {
    /**
     * The ID of the bowler
     * @type {string}
     * @memberof DeliveryBowler1
     */
    id: string;
    /**
     * The name of the bowler
     * @type {string}
     * @memberof DeliveryBowler1
     */
    name: string;
}
/**
 * Provides wicket details if a wicket fell
 * @export
 * @interface DeliveryDismissal
 */
export interface DeliveryDismissal {
    /**
     * 
     * @type {DeliveryBatsman}
     * @memberof DeliveryDismissal
     */
    batsman: DeliveryBatsman;
    /**
     * 
     * @type {DeliveryBowler1}
     * @memberof DeliveryDismissal
     */
    bowler: DeliveryBowler1;
    /**
     * The dismissal code
     * @type {string}
     * @memberof DeliveryDismissal
     */
    dismissalCode: DismissalCodeEnum;
    /**
     * Indicates if the wicket is attributable to the bowler
     * @type {boolean}
     * @memberof DeliveryDismissal
     */
    attributableToBowler: boolean;
    /**
     * 
     * @type {DeliveryFielder}
     * @memberof DeliveryDismissal
     */
    fielder?: DeliveryFielder;
}

/**
 * 
 * @export
 * @interface DeliveryFielder
 */
export interface DeliveryFielder {
    /**
     * The ID of the fielder in the dismissal
     * @type {string}
     * @memberof DeliveryFielder
     */
    id: string;
    /**
     * The name of the fielder involved in the dismissal
     * @type {string}
     * @memberof DeliveryFielder
     */
    name: string;
}

/**
 * 
 * @export
 * @interface DeliveryNonStriker
 */
export interface DeliveryNonStriker {
    /**
     * The ID of the non striker
     * @type {string}
     * @memberof DeliveryNonStriker
     */
    id: string;
    /**
     * The name of the non striker
     * @type {string}
     * @memberof DeliveryNonStriker
     */
    name: string;
}

/**
 * 
 * @export
 * @interface DeliveryStriker
 */
export interface DeliveryStriker {
    /**
     * The ID of the striker
     * @type {string}
     * @memberof DeliveryStriker
     */
    id: string;
    /**
     * The name of the striker
     * @type {string}
     * @memberof DeliveryStriker
     */
    name: string;
}

/**
 * The umpires for the match
 * @export
 * @interface UmpireSheet
 */
export interface UmpireSheet {
    /**
     * 
     * @type {UmpireSheetMatchReferee}
     * @memberof UmpireSheet
     */
    matchReferee: UmpireSheetMatchReferee;
    /**
     * The match umpires
     * @type {Array<InlineResponse2004>}
     * @memberof UmpireSheet
     */
    matchUmpires: Array<UmpireSheetMatchReferee>;
    /**
     * 
     * @type {UmpireSheetMatchReferee}
     * @memberof UmpireSheet
     */
    tvUmpire: UmpireSheetMatchReferee;
    /**
     * 
     * @type {UmpireSheetMatchReferee}
     * @memberof UmpireSheet
     */
    reserveUmpire: UmpireSheetMatchReferee;
}

/**
 * The match referee
 * @export
 * @interface UmpireSheetMatchReferee
 */
export interface UmpireSheetMatchReferee {
    /**
     * The ID of the person
     * @type {string}
     * @memberof UmpireSheetMatchReferee
     */
    id: string;
    /**
     * The legacy ID of the person
     * @type {string}
     * @memberof UmpireSheetMatchReferee
     */
    legacyId?: string;
    /**
     * The first name of the person
     * @type {string}
     * @memberof UmpireSheetMatchReferee
     */
    firstName: string;
    /**
     * The middle names of the person
     * @type {Array<string>}
     * @memberof UmpireSheetMatchReferee
     */
    middleNames?: Array<string>;
    /**
     * The last name of the person
     * @type {string}
     * @memberof UmpireSheetMatchReferee
     */
    lastName: string;
    /**
     * The display name of the person
     * @type {string}
     * @memberof UmpireSheetMatchReferee
     */
    name: string;
    /**
     * The nickname of the person
     * @type {Array<string>}
     * @memberof UmpireSheetMatchReferee
     */
    nickNames?: Array<string>;
    /**
     * The date of birth of the person
     * @type {string}
     * @memberof UmpireSheetMatchReferee
     */
    dateOfBirth?: string;
    /**
     * The gender of the peson
     * @type {string}
     * @memberof UmpireSheetMatchReferee
     */
    gender: GenderEnum;
    /**
     * The country of the umpire
     * @type {string}
     * @memberof UmpireSheetMatchReferee
     */
    country?: CountryEnum;
}


/**
 * The first team sheet for the match
 * @export
 * @interface TeamSheet
 */
export interface TeamSheet {
    /**
     * 
     * @type {Team}
     * @memberof TeamSheet
     */
    team: Team;
    /**
     * 
     * @type {Coach}
     * @memberof TeamSheet
     */
    coach: Coach;
    /**
     * List of player cards for the match
     * @type {Array<PlayerCard>}
     * @memberof TeamSheet
     */
    players: Array<PlayerCard>;
    /**
     * Indicates if the team is the home team
     * @type {boolean}
     * @memberof TeamSheet
     */
    homeTeam: boolean;
}

/**
 * 
 * @export
 * @interface Team
 */
export interface Team {
    /**
     * The ID of the team
     * @type {string}
     * @memberof Team
     */
    id: string;
    /**
     * The legacy ID of the person
     * @type {string}
     * @memberof Team
     */
    legacyId?: string;
    /**
     * The name of the team
     * @type {string}
     * @memberof Team
     */
    name: string;
    /**
     * The gender of the team
     * @type {string}
     * @memberof Team
     */
    gender: GenderEnum;
    /**
     * The code of the team
     * @type {string}
     * @memberof Team
     */
    teamCode?: CodeEnum;
    /**
     * List of players for the Team
     * @type {Array<Player>}
     * @memberof Team
     */
    players?: Array<Player>;
    /**
     * The ISO3166-1 country code of the team
     * @type {string}
     * @memberof Team
     */
    country?: CountryEnum;
    /**
     * The league of the team
     * @type {string}
     * @memberof Team
     */
    league?: string;
}


/**
 * 
 * @export
 * @interface PlayerCard
 */
export interface PlayerCard {
    /**
     * 
     * @type {Player}
     * @memberof PlayerCard
     */
    player: Player;
    /**
     * The batting position of the player
     * @type {number}
     * @memberof PlayerCard
     */
    battingPosition?: number;
    /**
     * The bowling position of the player
     * @type {number}
     * @memberof PlayerCard
     */
    bowlingPosition?: number;
    /**
     * Indicates if the player is the captain
     * @type {boolean}
     * @memberof PlayerCard
     */
    isCaptain: boolean;
    /**
     * Indicates if the player is the vice captain
     * @type {boolean}
     * @memberof PlayerCard
     */
    isViceCaptain: boolean;
    /**
     * Indicates if the player is the wicketkeeper
     * @type {boolean}
     * @memberof PlayerCard
     */
    isWicketkeeper: boolean;
    /**
     * Indicates if the player is a substitute
     * @type {boolean}
     * @memberof PlayerCard
     */
    isSubstitute: boolean;
}

/**
 * 
 * @export
 * @interface Player
 */
export interface Player {
    /**
     * The ID of the person
     * @type {string}
     * @memberof Player
     */
    id: string;
    /**
     * The legacy ID of the person
     * @type {string}
     * @memberof Player
     */
    legacyId?: string;
    /**
     * The first name of the person
     * @type {string}
     * @memberof Player
     */
    firstName: string;
    /**
     * The middle names of the person
     * @type {Array<string>}
     * @memberof Player
     */
    middleNames?: Array<string>;
    /**
     * The last name of the person
     * @type {string}
     * @memberof Player
     */
    lastName: string;
    /**
     * The display name of the person
     * @type {string}
     * @memberof Player
     */
    name: string;
    /**
     * The nicknames of the person
     * @type {Array<string>}
     * @memberof Player
     */
    nickNames?: Array<string>;
    /**
     * The date of birth of the person
     * @type {string}
     * @memberof Player
     */
    dateOfBirth?: string;
    /**
     * The gender of the peson
     * @type {string}
     * @memberof Player
     */
    gender: GenderEnum;
    /**
     * The batting hand of the player
     * @type {string}
     * @memberof Player
     */
    battingHand: BattingHandEnum;
    /**
     * The bowling style of the player
     * @type {string}
     * @memberof Player
     */
    bowlingStyle?: BowlingStyleEnum;
    /**
     * The country of the player
     * @type {string}
     * @memberof Player
     */
    country?: CountryEnum;
}

/**
 * The coach of the team
 * @export
 * @interface Coach
 */
export interface Coach {
    /**
     * The ID of the person
     * @type {string}
     * @memberof Coach
     */
    id: string;
    /**
     * The legacy ID of the person
     * @type {string}
     * @memberof Coach
     */
    legacyId?: string;
    /**
     * The first name of the person
     * @type {string}
     * @memberof Coach
     */
    firstName: string;
    /**
     * The middle names of the person
     * @type {Array<string>}
     * @memberof Coach
     */
    middleNames?: Array<string>;
    /**
     * The last name of the person
     * @type {string}
     * @memberof Coach
     */
    lastName: string;
    /**
     * The display name of the person
     * @type {string}
     * @memberof Coach
     */
    name: string;
    /**
     * The nicknames of the person
     * @type {Array<string>}
     * @memberof Coach
     */
    nickNames?: Array<string>;
    /**
     * The date of birth of the person
     * @type {string}
     * @memberof Coach
     */
    dateOfBirth?: string;
    /**
     * The gender of the peson
     * @type {string}
     * @memberof Coach
     */
    gender: GenderEnum;
    /**
     * The country of the coach
     * @type {string}
     * @memberof Coach
     */
    country?: CountryEnum;
}

/**
 * The series of the match
 * @export
 * @interface Series
 */
export interface Series {
    /**
     * The name of the series
     * @type {string}
     * @memberof Series
     */
    name: string;
    /**
     * The governing body of the series
     * @type {string}
     * @memberof Series
     */
    governingBody?: string;
}

/**
 * 
 * @export
 * @interface Match
 */
export interface Match {
    /**
     * The ID of the match
     * @type {string}
     * @memberof Match
     */
    id: string;
    /**
     * The legacy ID of the match
     * @type {string}
     * @memberof Match
     */
    legacyId?: string;
    /**
     * The start date and time of the match
     * @type {string}
     * @memberof Match
     */
    startDate: string;
    /**
     * The finish date and time of the match
     * @type {string}
     * @memberof Match
     */
    finishDate?: string;
    /**
     * The days of play in the match
     * @type {Array<string>}
     * @memberof Match
     */
    matchDays?: Array<string>;
    /**
     * The type of match
     * @type {string}
     * @memberof Match
     */
    matchType: MatchTypeEnum;
    /**
     * The sessions in the match
     * @type {Array<MatchSession>}
     * @memberof Match
     */
    sessions?: Array<MatchSession>;
    /**
     * Gender of the players in the match
     * @type {string}
     * @memberof Match
     */
    gender: GenderEnum;
    /**
     * 
     * @type {MatchWinner}
     * @memberof Match
     */
    winner?: MatchWinner;
    /**
     * 
     * @type {MatchToss}
     * @memberof Match
     */
    toss?: MatchToss;
    /**
     * The decision of the team that won the toss
     * @type {string}
     * @memberof Match
     */
    tossDecision?: TossDecisionEnum;
    /**
     * 
     * @type {UmpireSheet}
     * @memberof Match
     */
    umpires: UmpireSheet;
    /**
     * The result of the match
     * @type {string}
     * @memberof Match
     */
    result: ResultEnum;
    /**
     * 
     * @type {TeamSheet}
     * @memberof Match
     */
    team1: TeamSheet;
    /**
     * 
     * @type {TeamSheet}
     * @memberof Match
     */
    team2: TeamSheet;
    /**
     * The season of the match
     * @type {string}
     * @memberof Match
     */
    season: SeasonEnum;
    /**
     * 
     * @type {Series}
     * @memberof Match
     */
    series?: Series;
    /**
     * 
     * @type {MatchVenue}
     * @memberof Match
     */
    venue: MatchVenue;
}

/**
 * 
 * @export
 * @interface MatchStatus
 */
// export interface MatchStatus {
//     /**
//      * The name of the match
//      * @type {string}
//      * @memberof Match
//      */
//     name: string;
//     /**
//      * The start date and time of the match
//      * @type {string}
//      * @memberof Match
//      */
//     startDate: string;
//     /**
//      * The end date and time of the match
//      * @type {string}
//      * @memberof Match
//      */
//     endDate?: string;
//     /**
//      * 
//      * @type {}
//      * @memberof Match
//     */
//     homeTeam: { id: string, name: string };
//     /**
//     * 
//     * @type {}
//     * @memberof Match
//    */
//     awayTeam: { id: string, name: string };
//     reviews?: ReviewSheet;
//     targetScore?: number;
//     targetOvers?: number,
//     status: StatusSheet,
//     /**
//     * The result of the match
//     * @type {string}
//     * @memberof Match
//     */
//     result?: ResultEnum;
// }

/**
 * 
 * @export
 * @interface MatchSession
 */
export interface MatchSession {
    /**
     * The session number
     * @type {number}
     * @memberof MatchSession
     */
    number: number;
    /**
     * The day number
     * @type {number}
     * @memberof MatchSession
     */
    day: number;
    /**
     * The start time of the session
     * @type {string}
     * @memberof MatchSession
     */
    startTime: string;
    /**
     * The finish time of the session
     * @type {string}
     * @memberof MatchSession
     */
    finishTime?: string;
}

/**
 * The winning team
 * @export
 * @interface MatchWinner
 */
export interface MatchWinner {
    /**
     * The ID of the team
     * @type {string}
     * @memberof MatchWinner
     */
    id: string;
    /**
     * The Legacy ID of the team
     * @type {string}
     * @memberof MatchWinner
     */
    legacyId?: string;
    /**
     * The name of the team
     * @type {string}
     * @memberof MatchWinner
     */
    name: string;
    /**
     * Gender of the players in the match winner
     * @type {string}
     * @memberof MatchWinner
     */
    gender: GenderEnum;
    /**
     * The code of the team
     * @type {string}
     * @memberof MatchWinner
     */
    teamCode?: CodeEnum;
    /**
     * List of players in the match winner
     * @type {Array<Player>}
     * @memberof MatchWinner
     */
    players?: Array<Player>;
    /**
     * The ISO3166-1 country code of the team
     * @type {string}
     * @memberof MatchWinner
     */
    country?: CountryEnum;
    /**
     * The league of the team
     * @type {string}
     * @memberof MatchWinner
     */
    league?: string;
}

/**
 * The team that won the toss
 * @export
 * @interface MatchToss
 */
export interface MatchToss {
    /**
     * The ID of the team
     * @type {string}
     * @memberof MatchToss
     */
    id: string;
    /**
     * The legacy ID of the team
     * @type {string}
     * @memberof MatchToss
     */
    legacyId?: string;
    /**
     * The name of the team
     * @type {string}
     * @memberof MatchToss
     */
    name: string;
    /**
     * Gender of the players in the team
     * @type {string}
     * @memberof MatchToss
     */
    gender: GenderEnum;
    /**
     * The code of the team
     * @type {string}
     * @memberof MatchToss
     */
    teamCode?: CodeEnum;
    /**
     * The ISO3166-1 country code of the team
     * @type {string}
     * @memberof MatchToss
     */
    country?: CountryEnum;
    /**
     * The league of the team
     * @type {string}
     * @memberof MatchToss
     */
    league?: string;
}

/**
 * The venue of the match
 * @export
 * @interface MatchVenue
 */
export interface MatchVenue {
    /**
     * The ID of the venue
     * @type {string}
     * @memberof MatchVenue
     */
    id: string;
    /**
     * The legacy ID of the venue
     * @type {string}
     * @memberof MatchVenue
     */
    legacyId?: string;
    /**
     * The name of the venue
     * @type {string}
     * @memberof MatchVenue
     */
    name: string;
    /**
     * The city of the venue
     * @type {string}
     * @memberof MatchVenue
     */
    city: string;
    /**
     * The region of the venue
     * @type {string}
     * @memberof MatchVenue
     */
    region?: string;
    /**
     * The ISO3166-1 country code of the venue
     * @type {string}
     * @memberof MatchVenue
     */
    country: CountryEnum;
    /**
     * The capacity of the venue
     * @type {number}
     * @memberof MatchVenue
     */
    capacity?: number;
    /**
     * 
     * @type {VenueLocation}
     * @memberof MatchVenue
     */
    location?: VenueLocation;
}

/**
 * The location of the venue
 * @export
 * @interface VenueLocation
 */
export interface VenueLocation {
    /**
     * 
     * @type {number}
     * @memberof VenueLocation
     */
    latitude: number;
    /**
     * 
     * @type {number}
     * @memberof VenueLocation
     */
    longitude: number;
}